import {ErpSidebarNavService, ErpTopbarService, TabPagesUrlManagementService} from 'src/features/erp/components';
import register from '@kpsys/angularjs-register';
import {FondPermissionsDataService} from './services/fond-permissions.data-service';
import {ErpFondPermissionsContextService} from './services/erp-fond-permissions-context.service';

export default register('portaro.features.erp', ['ui.router'])
    .service(ErpSidebarNavService.serviceName, ErpSidebarNavService)
    .service(ErpTopbarService.serviceName, ErpTopbarService)

    // Fond permissions
    .service(FondPermissionsDataService.serviceName, FondPermissionsDataService)
    .service(ErpFondPermissionsContextService.serviceName, ErpFondPermissionsContextService)

    // Tabbed subpages URL management
    .service(TabPagesUrlManagementService.serviceName, TabPagesUrlManagementService)

    .name();